<template>
  <div>
    <table-temp
      title
      :flag="1"
      :tableData="tableData"
      :columnData="tableConf"
      @editTable="editTable"
      @handleSelectionChange="handleSelectionChange"
      :showSummary="true"
      :summaryMethod="getSummaries"
    >
      <div slot="tool">
        <el-button class="borderBtn" @click="addDialog">添加</el-button>
        <el-button class="borderBtn" @click="delProduct">删除</el-button>
      </div>
    </table-temp>
    <step-dialog
      :dialogVisible="dialogVisible"
      :title="title"
      @closeDialog="closeDialog"
      @reload="reloadData"
      :data="commonData"
      :codeId="codeId"
      :key="key"
    ></step-dialog>
    <div class="footerBtn">
      <el-button @click="pre">上一步</el-button>
      <el-button class="mainBtn" @click="save">保存</el-button>
      <el-button class="mainBtn" @click="next">保存并下一步</el-button>
    </div>
  </div>
</template>

<script>
import TableTemp from "@table/table";
import { step3Agency } from "@/conf/Report-angency";
import StepDialog from "../dialog/agencyStep3Dialog";
import comMixin from "common/js/mixin/comMixin";

import { mapState, mapMutations } from "vuex";
import { getFundNewInvested, delFundNewInveste } from "common/js/api";

export default {
  components: {
    TableTemp,
    StepDialog,
  },

  mixins: [comMixin],

  data() {
    return {
      title: "",
      tableData: [],
      tableConf: [],
      dialogVisible: false,
      isManager: true,
      codeId: this.$route.query.codeId,
      commonData: {},
      selectIds: "",
      step: 2,
      key: 0,
    };
  },

  created() {
    // 设置配环境
    this.setEnvironment();
  },

  mounted() {
    this.setConf();
    // 查询vuex数据
    // this.setData();
    this.getFundListData();
  },

  methods: {
    //合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => {
          if (column.property === "investeCapital") {
            return Number(item[column.property]);
          }
        });
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + "";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    async getFundListData() {
      const res = await getFundNewInvested(this.codeId);
      this.tableData = res.result;
      this.tableData.forEach((item) => {
        item.investeTime = this.$moment(item.investeTime).format("YYYY-MM-DD");
      });
    },

    reloadData() {
      this.getFundListData();
    },

    handleSelectionChange(ids) {
      this.selectIds = ids;
    },

    async delProduct() {
      if (!this.selectIds) {
        this.$message({
          message: "请先选择删除的列表,再点击删除!",
          type: "warning",
        });
        return;
      }
      await delFundNewInveste(this.selectIds);
      this.$message({
        message: "删除成功!",
        type: "success",
      });
      this.reloadData();
    },

    async save() {
      return true;
    },

    setEnvironment() {
      const path = this.$route.path;
      if (path == "/QuaReport/AgencyMan") {
        this.isManager = true;
      } else {
        this.isManager = false;
      }
    },

    setConf() {
      this.tableConf = step3Agency;
    },

    addDialog(val) {
      this.commonData = {};
      this.title = "添加年内拟新增投资情况";
      this.$set(this.commonData, "dte", new Date());
      let investeTime = this.$moment(new Date()).format("YYYY-MM-DD");
      this.$set(this.commonData, "investeTime", investeTime);
      this.key++;
      this.dialogVisible = true;
    },

    editTable(val) {
      this.title = "编辑年内拟新增投资情况";
      this.commonData = val.scope.row;
      this.$set(this.commonData, "dte", new Date());
      this.key++;
      this.dialogVisible = true;
    },

    closeDialog() {
      this.dialogVisible = false;
    },
  },

  computed: {
    ...mapState({
      reportData(state) {
        return state.ReportData.reportData;
      },
    }),
  },
};
</script>

<style></style>
